import { useIntl } from 'react-intl';
import { TextField } from '@material-ui/core';
import { validateOrderCode } from './utils';

interface OrderCodeFieldProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
}

const OrderCodeField = ({
  id,
  value,
  onChange,
  error,
  disabled,
}: OrderCodeFieldProps) => {
  const intl = useIntl();
  // Show format problems while typing; the prefix itself is optional.
  const visibleError = error || validateOrderCode(value);

  return (
    <TextField
      id={id}
      fullWidth
      variant="outlined"
      disabled={disabled}
      label={intl.formatMessage({ id: 'ORDERS.ORDER_CODE' })}
      value={value}
      onChange={(event) => onChange(event.target.value.toUpperCase())}
      inputProps={{ maxLength: 6, autoCapitalize: 'characters' }}
      error={Boolean(visibleError)}
      helperText={
        visibleError
          ? intl.formatMessage({ id: visibleError })
          : intl.formatMessage(
              { id: 'ORDERS.ORDER_CODE_HELP' },
              { prefix: value.trim() },
            )
      }
    />
  );
};

export default OrderCodeField;
